<div
  class="op-modal dynamic-content-modal--wrapper loading-indicator--location"
  data-indicator-name="modal"
></div>
